/**
 * Holds (03 §4.3, 08 §6). Exclusive per room per overlapping window by a database constraint; at most
 * one active hold per lead per date. A constraint violation is `409 HOLD_CONFLICT` with alternatives.
 */
import { z } from 'zod';
import { Actor, DateString, Id, Instant, InstantRange, TimeHHmm, Timestamps } from './common.js';
import { Alternative } from './availability.js';
export const HoldStatus = z.enum(['active', 'released', 'converted', 'expired']);
export const Hold = z.object({
    id: Id,
    leadId: Id,
    productId: Id,
    /** Denormalised leaf rooms of the product at the time of the hold. */
    roomIds: z.array(Id),
    date: DateString,
    start: TimeHHmm,
    durationMinutes: z.number().int().positive(),
    /** Occupied window including setup and teardown. */
    window: InstantRange,
    expiresAt: Instant,
    status: HoldStatus,
    createdBy: Actor,
    releasedAt: Instant.nullable(),
    releasedBy: Actor.nullable(),
    ...Timestamps,
});
/** `POST /g/holds` */
export const CreateHoldBody = z.object({
    productId: Id,
    date: DateString,
    start: TimeHHmm,
    durationMinutes: z.number().int().min(30).max(1440),
});
/** `details` of a `409 HOLD_CONFLICT` error. */
export const HoldConflictDetails = z.object({ alternatives: z.array(Alternative) });
/** `POST /s/holds/:id/extend` */
export const ExtendHoldBody = z.object({
    hours: z
        .number()
        .int()
        .min(1)
        .max(24 * 14),
});
//# sourceMappingURL=holds.js.map